module.exports = __webpack_public_path__ + "src/assets/textures/env/tractor/fuel_window_512_bake.png";